module.exports = __webpack_public_path__ + "media/images/hero/glyph-c4-b74ee7ce652d5595a09515b68524eb6a.svg";